import { registerHtml, TramOneComponent } from 'tram-one';
import { useNotification } from '../hooks/notification';
import XControl from './XControl';

const html = registerHtml({
	XControl,
});

const NotificationBanner: TramOneComponent = () => {
	const { getNotificationMessage, dismissNotification } = useNotification();
	const { message, type, visible } = getNotificationMessage();

	const onDismissNotification = () => {
		dismissNotification();
	};

	if (!visible) {
		return html` <section class="NotificationBanner"></section>`;
	}

	return html` <section class="NotificationBanner notification-${type}">
		<a>${message}</a>
		<XControl onselect=${onDismissNotification} />
	</section>`;
};

export default NotificationBanner;
